var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConsumer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.017,
    height: 38.982,
    viewBox: "0 0 39.017 38.982",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Consumer",
    transform: "translate(-564.907 -3203.174)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_185",
    "data-name": "Path 185",
    d: "M464.438,1016.438h28.578l-5.971,16.42a1.586,1.586,0,0,1-1.491,1.045H467.428a1.589,1.589,0,0,1-1.577-1.391l-3-24.012H456.5",
    transform: "translate(109.657 2195.924)",
    fill: "none",
    stroke: "#007513",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1083",
    "data-name": "Ellipse 1083",
    cx: 3.138,
    cy: 3.138,
    rx: 3.138,
    ry: 3.138,
    transform: "translate(591.536 3234.63)",
    fill: "none",
    stroke: "#007513",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1084",
    "data-name": "Ellipse 1084",
    cx: 3.138,
    cy: 3.138,
    rx: 3.138,
    ry: 3.138,
    transform: "translate(574.157 3234.63)",
    fill: "none",
    stroke: "#007513",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsumer);
export default __webpack_public_path__ + "static/media/Consumer.a092a9ad2e2ef33057e33dd7cb5bf850.svg";
export { ForwardRef as ReactComponent };